import React, { useState } from "react";
import styled from "styled-components";
import { T } from "../../theme";
import { FAQ as FAQ_DATA } from "../../data/careers";
import Reveal from "../Reveal";
import { Band, Shell, Eyebrow, Heading, Head } from "./ui";

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 820px;
`;

const ItemWrap = styled.div`
  border: 1.5px solid ${T.border};
  border-radius: 14px;
  background: ${T.card};
  overflow: hidden;
  transition: border-color 0.16s;

  ${(p) => p.$open && `border-color: color-mix(in srgb, var(--purple) 36%, transparent);`}
`;

const Q = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 18px 20px;
  cursor: pointer;
  font-size: 0.92rem;
  font-weight: 700;
  color: ${T.text};
  transition: color 0.14s;

  &:hover { color: var(--purple); }
`;

const Icon = styled.span`
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--purple);
  transition: transform 0.22s ease;
  transform: rotate(${(p) => (p.$open ? "45deg" : "0deg")});
  font-size: 1.3rem;
  font-weight: 400;
`;

const A = styled.div`
  max-height: ${(p) => (p.$open ? "320px" : "0")};
  opacity: ${(p) => (p.$open ? 1 : 0)};
  transition: max-height 0.28s ease, opacity 0.22s ease, padding 0.28s ease;
  padding: ${(p) => (p.$open ? "0 20px 19px" : "0 20px")};

  p {
    font-size: 0.86rem;
    color: ${T.muted};
    line-height: 1.7;
  }
`;

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <Band id="faq" $soft $top aria-labelledby="faq-title">
      <Shell>
        <Reveal>
          <Head>
            <Eyebrow>Dúvidas frequentes</Eyebrow>
            <Heading id="faq-title">Perguntas que todo candidato faz.</Heading>
          </Head>
        </Reveal>

        <Reveal>
          <List>
            {FAQ_DATA.map((item, i) => {
              const isOpen = open === i;
              return (
                <ItemWrap key={i} $open={isOpen}>
                  <Q
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-a-${i}`}
                  >
                    {item.q}
                    <Icon $open={isOpen} aria-hidden="true">+</Icon>
                  </Q>
                  <A id={`faq-a-${i}`} $open={isOpen} role="region">
                    <p>{item.a}</p>
                  </A>
                </ItemWrap>
              );
            })}
          </List>
        </Reveal>
      </Shell>
    </Band>
  );
}
